module.exports = __webpack_public_path__ + "img/lachmania_no.5e9820fe.png";